// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"b33226c3","977":"07c57fc1"}[chunkId] + ".chunk.js";
};